// polyfill for .closest()
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
if ( ! Element.prototype.matches ) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;
}

if ( ! Element.prototype.closest ) {
    Element.prototype.closest = function( s ) {
        var el = this;
        if ( ! document.documentElement.contains( el ) ) {
			return null;
        }
        do {
            if ( el.matches( s ) ) {
				return el;
            };
            el = el.parentElement || el.parentNode;
        } while ( el !== null && el.nodeType === 1 );
        return null;
    };
}

( function() {
	var container, button, menu, links, i, len, navItems, menuToggleButton, subMenuButtons, mobileMenuOpen, id, link, button, subMenu;

	container = document.getElementById( 'site-menu' );
	menuToggleButton = document.getElementById( 'menu-toggle' );
	menu = document.getElementById( 'top-menu' );
	
	if (
		'undefined' === typeof container ||
		'undefined' === typeof menu
	) {
		return;
	}

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		menuToggleButton.style.display = 'none';
		return;
	}

	container.className = container.className.replace( 'menu-no-js', '' );
	container.setAttribute( 'tabindex', '-1' );

	function toggleMobileMenu() {
		if ( 'true' === menuToggleButton.getAttribute( 'aria-expanded' ) ) {
			container.className = container.className.replace( ' toggled-on', '' );
			menuToggleButton.setAttribute( 'aria-expanded', 'false' );
			mobileMenuOpen = false;
		} else {
			container.className += ' toggled-on';
			menuToggleButton.setAttribute( 'aria-expanded', 'true' );
			mobileMenuOpen = true;
			container.focus();
		}
	};

	menuToggleButton.addEventListener( 'click', toggleMobileMenu );

	document.addEventListener( 'click', function( e ) {

		if ( ! e.target.closest( '.main-navigation' ) ) {
			closeOpenSubMenus( false );
		}

	});

	container.addEventListener( 'keyup', function( e ) {
		if ( 27 === e.keyCode && mobileMenuOpen ) {
			toggleMobileMenu();
			menuToggleButton.focus();
		}
	});

	navItems = document.querySelectorAll( '#top-menu > li' );

	/**
	 * set up menu by
	 * 		1. replacing top-level links with buttons if there's a submenu
	 *   	2. setting appropriate aria on buttons and submenus
	 */
	for ( i = 0, len = navItems.length; i < len; i++ ) {
		subMenu = navItems[i].getElementsByClassName( 'sub-menu' )[0];

		if ( 'undefined' !== typeof subMenu ) {
			// replace link with button
			id = navItems[i].getAttribute( 'id' ) + '-sub-menu';
			link = navItems[i].getElementsByTagName( 'a' )[0];
			button = document.createElement( 'button' );
			button.innerHTML = link.innerHTML;
			button.setAttribute( 'aria-controls', id );
			button.setAttribute( 'aria-expanded', false );
			navItems[i].replaceChild( button, link );

			// tweak submenu
			subMenu.setAttribute( 'id', id );
			subMenu.setAttribute( 'aria-hidden', true );
		}
	}

	subMenuButtons = document.querySelectorAll( '#top-menu button' );
	for ( i = 0, len = subMenuButtons.length; i < len; i++ ) {
		subMenuButtons[i].addEventListener( 'click', toggleSubMenu );
	}

	function toggleSubMenu() {

		var self = this;
		var subMenu = document.getElementById( self.getAttribute( 'aria-controls' ) );

		closeOpenSubMenus( self );

		if ( 'true' === self.getAttribute( 'aria-expanded' ) ) {
			self.setAttribute( 'aria-expanded', false );
			subMenu.setAttribute( 'aria-hidden', true );
		} else {
			self.setAttribute( 'aria-expanded', true );
			preventOffScreen( self );
			subMenu.setAttribute( 'aria-hidden', false );
		}

	}

	function closeOpenSubMenus( skipElement ) {
		var buttons = container.querySelectorAll( 'button[aria-expanded="true"]' ),
			subMenus = document.querySelectorAll( '.sub-menu[aria-hidden="false"]' );

		for ( i = 0, len = buttons.length; i < len; i++ ) {
			if ( false === skipElement || buttons[i] !== skipElement ) {
				buttons[i].setAttribute( 'aria-expanded', false );
			}
		}

		for ( i = 0, len = subMenus.length; i < len; i++ ) {
			if (
				false === skipElement ||
				subMenus[i].getAttribute( 'id' ) !== skipElement.getAttribute( 'aria-controls' )
			) {
				subMenus[i].setAttribute( 'aria-hidden', true );
			}
		}

	}

	function preventOffScreen( parentItem ) {

		var screenWidth, menuLeftEdge, menuRightEdge;

		screenWidth = 	window.innerWidth ||
						document.documentElement.clientWidth ||
						document.body.clientWidth;
		menuLeftEdge = parentItem.getBoundingClientRect().left;
		menuRightEdge = menuLeftEdge + 212; // 212 = menu width

		// 30 just to avoid things that are too tight
		if ( menuRightEdge + 30 > screenWidth ) {
			subMenu.className += ' offscreen-submenu';
		}

	}

}() );
